import React from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Mutation } from 'react-apollo';
import { FormattedMessage } from 'react-intl';
import { CustomButton } from '../../containers';
import { AdminUpdateUserActiveStatusMutation } from '../../operations/mutations/AdminUpdateUserMutation';
import { handleRequestError } from '../../constants/errorCodes';
import { renderToaster, SUCCESS_TOASTER } from '../../constants/toaster';

export const ConfirmActivationChangeModal = ({ isOpen, toggle, user, setAccountActive, accountActive }) => {
  const dispatch = useDispatch();

  return (
    <Modal modalClassName="hok-modal" centered size="sm" backdrop="static" toggle={toggle} isOpen={isOpen}>
      <ModalHeader className="border-0">
        <Row className="no-gutters auth-nav-links">
          <Col xs={12}>
            <h2 className="d-flex align-items-center justify-content-center">
              <FormattedMessage
                id={accountActive ? 'adminEditUserPage.activateTitle' : 'adminEditUserPage.deactivateTitle'}
              />
            </h2>
          </Col>
        </Row>
      </ModalHeader>
      <ModalBody>
        <Row className="no-gutters px-4 py-3 font-weight-500">
          <Col xs="12" className="text-center">
            <FormattedMessage
              id={
                accountActive
                  ? 'adminEditUserPage.areYouSureToActivateUser'
                  : 'adminEditUserPage.areYouSureToDeactivateUser'
              }
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Row className="w-100">
          <Col xs={6}>
            <CustomButton className="hok-outline-btn" outline translationId="no" onClick={toggle} />
          </Col>
          <Col xs={6}>
            <Mutation
              mutation={AdminUpdateUserActiveStatusMutation}
              onError={error => handleRequestError(error, dispatch)}
              onCompleted={() =>
                renderToaster(`successMessages.userActiveStatusUpdated`, SUCCESS_TOASTER, { intlKey: true })
              }>
              {(updateActiveStatus, { loading }) => {
                return (
                  <CustomButton
                    type="submit"
                    className="hok-dashboard-btn"
                    translationId="yes"
                    onClick={() => {
                      updateActiveStatus({
                        variables: {
                          id: user.id,
                          email: user.email,
                          phoneNumber: user.phoneNumber,
                          activated: !accountActive,
                        },
                      });
                      setAccountActive(!accountActive);
                      toggle();
                    }}
                    loaderProp={loading}
                  />
                );
              }}
            </Mutation>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  );
};
